import React, { createContext, useContext, useEffect, useState } from 'react';

const AdminAuthCtx = createContext(null);

export const AdminAuthProvider = ({ children }) => {
  const [password, setPassword] = useState(() => sessionStorage.getItem('bg_admin_pw') || '');
  const [isAuthed, setIsAuthed] = useState(false);

  useEffect(() => {
    // Attempt to reload authed session
    const pw = sessionStorage.getItem('bg_admin_pw');
    if (pw) setIsAuthed(true);
  }, []);

  const login = (pw) => {
    setPassword(pw);
    sessionStorage.setItem('bg_admin_pw', pw);
    setIsAuthed(true);
  };

  const logout = () => {
    setPassword('');
    sessionStorage.removeItem('bg_admin_pw');
    setIsAuthed(false);
  };

  return (
    <AdminAuthCtx.Provider value={{ password, isAuthed, login, logout }}>
      {children}
    </AdminAuthCtx.Provider>
  );
};

export const useAdminAuth = () => useContext(AdminAuthCtx);
